module.exports = __webpack_public_path__ + "bn.svg?76f65fc02b074d9f184fe2ff730c4fa4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bn.svg
// module id = 1010
// module chunks = 27